import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { filterPeople, setFilters, resetFilters } from '../actions'
import { CourseSectionFilter } from './CourseSectionFilter'

class FilterForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      lastName: '',
      firstName: '',
      email: '',
      signupDateUpperBound: '',
      signupDateLowerBound: '',
      courseSection: 'All Sections',
      displayFilterReset: false,
      lastLoginLowerBound: '',
      lastLoginUpperBound: '',
    }

    this.resetFilters = this.resetFilters.bind(this)
  }

  handleText = event => {
    this.setState({ [event.target.name]: event.target.value })
  }

  filter = event => {
    event.preventDefault()

    let filters = {}
    filters.lastNameFilter = this.state.lastName
    filters.firstNameFilter = this.state.firstName
    filters.emailFilter = this.state.email
    filters.signupDateUpperBound = this.state.signupDateUpperBound
    filters.signupDateLowerBound = this.state.signupDateLowerBound
    filters.sectionFilter = this.state.courseSection
    filters.lastLoginLowerBound = this.state.lastLoginLowerBound
    filters.lastLoginUpperBound = this.state.lastLoginUpperBound
    filters.pageNum = this.props.currentCourseMemPage
    filters.archivedPageNum = this.props.currentArchivePage

    this.props.setFilters(filters)
    this.props.sendFilter(filters)

    this.setState({
      displayFilterReset: true,
    })
  }

  resetFilters() {
    this.setState({
      lastName: '',
      firstName: '',
      email: '',
      signupDateLowerBound: '',
      signupDateUpperBound: '',
      courseSection: 'All Sections',
      displayFilterReset: false,
      lastLoginLowerBound: '',
      lastLoginUpperBound: '',
    })
    this.props.resetFilters()
    this.props.sendFilter()
  }

  allFilters() {
    let filters = ['All Sections', 'Unassigned Members']
    this.props.allSectionData.map(sec => filters.push(sec.secName))

    return filters
  }

  render() {
    return (
      <div>
        <form>
          <div className="form-group">
            <div>
              <label htmlFor="lastName">Last Name Contains:</label>
            </div>
            <input
              className="form-control"
              id="lastName"
              name="lastName"
              value={this.state.lastName}
              onChange={this.handleText}
              type="text"
            />
            <div>
              <label htmlFor="firstName">First Name Contains:</label>
            </div>
            <input
              className="form-control"
              id="firstName"
              name="firstName"
              value={this.state.firstName}
              onChange={this.handleText}
              type="text"
            />
            <div>
              <label htmlFor="email">Email Address Contains:</label>
            </div>
            <input
              className="form-control"
              id="email"
              name="email"
              value={this.state.email}
              onChange={this.handleText}
              type="text"
            />
          </div>
          <div className="form-group">
            <div>
              <label htmlFor="signupDates">Signup Date Between:</label>
            </div>
            <input
              className="form-control"
              id="signupDates"
              name="signupDateLowerBound"
              value={this.state.signupDateLowerBound}
              onChange={this.handleText}
              type="date"
            />
            <div>
              <label htmlFor="signupDatesUpperBound">and</label>
            </div>
            <input
              className="form-control"
              id="signupDatesUpperBound"
              name="signupDateUpperBound"
              value={this.state.signupDateUpperBound}
              onChange={this.handleText}
              type="date"
            />
          </div>
          <div>
            <div>
              <label htmlFor="loginLower">Last Login Date Between:</label>
            </div>
            <input
              className="form-control"
              id="loginLower"
              name="lastLoginLowerBound"
              value={this.state.lastLoginLowerBound}
              onChange={this.handleText}
              type="date"
            />
            <div>
              <label htmlFor="loginUpper">and</label>
            </div>
            <input
              className="form-control"
              id="loginUpper"
              name="lastLoginUpperBound"
              value={this.state.lastLoginUpperBound}
              onChange={this.handleText}
              type="date"
            />
          </div>
          <div>
            <label htmlFor="courseSections">Course Section:</label>
            <div
              id="courseSections"
              className="bg-white d-block border rounded p-3"
            >
              <ul className="d-table-row">
                <fieldset>
                  {this.allFilters().map((secFilter, i) => (
                    <CourseSectionFilter
                      filter={secFilter}
                      checkedFilter={this.state.courseSection}
                      handleText={this.handleText}
                      key={i}
                    />
                  ))}
                </fieldset>
              </ul>
            </div>
          </div>
          <div className="mt-4">
            <button
              className="btn btn-default btn-myed btn-default-myed"
              type="submit"
              onClick={this.filter}
            >
              Apply Filters
            </button>
            {this.state.displayFilterReset ? (
              <button
                className="btn btn-default btn-myed btn-default-myed ml-1"
                type="reset"
                onClick={this.resetFilters}
              >
                Reset
              </button>
            ) : null}
          </div>
        </form>
      </div>
    )
  }
}
FilterForm.propTypes = {
  peopleRows: PropTypes.array,
  sendFilter: PropTypes.func,
  setFilters: PropTypes.func,
  resetFilters: PropTypes.func,
  sectionRows: PropTypes.array,
  allSectionData: PropTypes.array,
  currentCourseMemPage: PropTypes.number,
  currentArchivePage: PropTypes.number,
}
const mapDispatchToProps = dispatch => {
  return {
    sendFilter: data => {
      dispatch(filterPeople(data))
    },
    setFilters: data => {
      dispatch(setFilters(data))
    },
    resetFilters: () => {
      dispatch(resetFilters())
    },
  }
}

const mapStateToProps = state => {
  return {
    peopleRows: state.peopleRowData,
    sectionRows: state.sectionRowData,
    allSectionData: state.allSectionData,
    currentCourseMemPage: state.currentCourseMemPage,
    currentArchivePage: state.currentArchivePage,
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(FilterForm)
